import { Box, Link as MuiLink, Paper, Typography } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BikeleasingTabs } from './BikeleasingContent';
import { BikeleasingVendorTabs } from './BikeleasingVendorContent';
import { useBikeleasingContracts } from './useBikeleasingDetails';

export const BikeleasingRegister: React.FC = () => {
  const contractList = useBikeleasingContracts();
  if (contractList && contractList.totalCount > 0) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: 1, marginTop: 1 }}>
      <Paper sx={{ boxShadow: 0, p: 1 }} data-test-id={'bikeleasing-register'}>
        <Typography>
          <Trans
            i18nKey={'extensions:bikeleasing_v2_benefit.registerNowInfo'}
            components={{
              dealerLink: <MuiLink component={Link} to={`?tab=${BikeleasingTabs.vendorMap}&vendorTab=${BikeleasingVendorTabs.MAP}`} />,
              onlineLink: <MuiLink component={Link} to={`?tab=${BikeleasingTabs.vendorMap}&vendorTab=${BikeleasingVendorTabs.ONLINE}`} />,
            }}
          />
        </Typography>
      </Paper>
    </Box>
  );
};
